<template>
  <v-application v-if="access.inv_fees">
    <v-layout row class="ma-2">
      <v-flex md12>
        <v-crud-card
          name="fees"
          to="/inventory/fees"
          v-bind:headers="headers"
          v-bind:data="fees"
          v-bind:num-pages="fees_total"
          v-model="page"
          @change-pagination="changePagination"
          :loading_items_table_data="data_loading"
          v-bind:add_button_name="'add_fee'"
          @calculateTotal="calculateTotal"
          noDelete
          Fees
        >
          <template #search>
            <v-flex class="px-2 mt-5 pt-4">
              <v-autocomplete
                v-model="options.fee_type"
                :label="$t('type')"
                :append-icon="''"
                :items="types"
                item-value="value"
                item-text="name"
              ></v-autocomplete>
            </v-flex>
            <v-flex class="px-2 mt-5 pt-4">
              <v-autocomplete
                v-model="options.amount_type"
                :label="$t('amount_type')"
                :append-icon="''"
                :items="amount_types"
                item-value="value"
                item-text="name"
              ></v-autocomplete>
            </v-flex>
            <v-flex class="px-2 mt-5 pt-4">
              <v-autocomplete
                v-model="options.service"
                :label="$t('store')"
                item-value="_id"
                :items="stores"
                item-text="name"
                :append-icon="''"
              ></v-autocomplete>
            </v-flex>
            <v-flex v-if="options.fee_type != ''" class="px-2 mt-5 pt-4">
              <v-autocomplete
                v-if="options.fee_type == 'salary'"
                v-model="options.filter"
                :label="$t('employee')"
                item-value="_id"
                item-text="name"
                :items="all_employees"
                :append-icon="''"
              ></v-autocomplete>
              <v-autocomplete
                v-else-if="options.fee_type == 'company_to_fees'"
                v-model="options.filter"
                :label="$t('type')"
                item-value="_id"
                item-text="supplier_name"
                :items="all_suppliers"
                :append-icon="''"
              ></v-autocomplete>
            </v-flex>
            <v-flex class="px-2 mt-2" md3 xs6>
              <v-datetime-picker
                v-model="options.start_date"
                solo
                label="Start date"
                v-bind:max="options.end_date"
              />
            </v-flex>
            <v-flex class="px-2 mt-2" md3 xs6>
              <v-datetime-picker
                v-model="options.end_date"
                solo
                label="End date"
                v-bind:min="options.start_date"
              />
            </v-flex>
            <v-btn icon @click="downloadExcel">
              <v-icon>mdi-download</v-icon>
            </v-btn>
            <v-dialog v-model="dialog" max-width="500px">
              <v-card>
                <v-card-title v-if="wait">Iltimos, kutib turing!</v-card-title>
                <v-card-title v-else>Excel yuklashga tayyor!</v-card-title>

                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn
                    text
                    color="primary"
                    @click="saveExcel"
                    :disabled="wait"
                  >
                    <export-excel :data="downExcel" :name="excel_name"
                      >Save Excel</export-excel
                    >
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
        </v-crud-card>
      </v-flex>
    </v-layout>
  </v-application>
  <error404 v-else></error404>
</template>
<script>
import Suppliers from "../../mixins/inventory/supplier";
import Currency from "../../mixins/settings/currency";
import Services from "../../mixins/services";
import Employees from "../../mixins/employees/workgroup";
import fileSaver from "file-saver";
import xlsx from "xlsx";

export default {
  name: "Fees",
  mixins: [Suppliers, Currency, Services, Employees],
  data: () => ({
    headers: [],
    fees: [],
    fees_total: 1,
    page: 1,
    options: {
      start_date: new Date(new Date().setDate(new Date().getDate() - 7))
        .toISOString()
        .substr(0, 10),
      end_date: new Date(new Date().setDate(new Date().getDate() + 1))
        .toISOString()
        .substr(0, 10),
      fee_type: "",
      amount_type: "",
      filter: null,
      service: "",
    },
    current_total: 0,
    downExcel: [],
    excel_name: "Fee",
    wait: true,
    dialog: false,
  }),
  computed: {
    amount_types() {
      return [
        {
          name: this.$t("all_amount"),
          value: "",
        },
        {
          name: this.$t("cash"),
          value: "cash",
        },
        {
          name: this.$t("card"),
          value: "card",
        },
      ];
    },
    types() {
      return [
        {
          name: this.$t("all_types"),
          value: "",
        },
        {
          name: this.$t("fees"),
          value: "fees",
        },
        {
          name: this.$t("one_time_fees"),
          value: "one_time_fees",
        },
        {
          name: this.$t("salary"),
          value: "salary",
        },
        {
          name: this.$t("company_to_fees"),
          value: "company_to_fees",
        },
      ];
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getConsumptions();
      },
    },
    "options.fee_type"() {
      if (this.options.fee_type == "salary") {
        this.get_all_employees();
      } else if (this.options.fee_type == "company_to_fees") {
        this.get_all_suppliers();
      } else {
        this.update_services();
      }
      this.options.filter = null;
    },
    fees: {
      deep: true,
      handler() {
        this.calculateTotal(this.fees);
      },
    },
  },
  methods: {
    calculateTotal(fees) {
      let items = this.$copy(fees);
      if (!(items instanceof Array)) {
        items = [];
      }

      let total = 0;
      for (const it of items) {
        if (it.currency == "usd") {
          if (this.currency && this.currency.value) {
            it.currency_amount *= this.currency.value;
          }
        }
        total += it.currency_amount;
      }
      this.current_total = total;
    },
    changePagination(page) {
      this.page = page;
      this.getConsumptions();
    },
    async downloadExcel() {
      this.data_loading = true;
      // this.dialog = true;
      const start = new Date(this.options.start_date).getTime();
      const end = new Date(this.options.end_date).getTime();
      this.data_loading = false;
      const result = this.$communicator.then(
        this,
        await this.$communicator("get_consumptions", {
          arguments: ['all', 1],
          params: {
            startDate: start,
            endDate: end,
            fee_type: this.options.fee_type,
            filter: this.options.filter,
            amount_type: this.options.amount_type,
            service: this.options.service,
          },
        })
      );
      const result_fee = await result?.fees.map((fee) => ({
        Type: fee.type,
        Employee: fee.by_name,
        To:
          fee.type == "company_to_fees"
            ? fee.supplier_name
            : fee.type == "salary"
            ? fee.employee_name
            : fee.service_name,
        Store: fee.service_name,
        Comment: fee.comment,
        Date: this.date_ddmmyy_hhmm(fee.date),
        Amount_type: fee.amount_type,
        Amount: fee.currency_amount,
      }));
      const ws = xlsx.utils.json_to_sheet(result_fee);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
      fileSaver.saveAs(data, "Fee.xlsx");
      // this.downExcel = await result_fee;
      // setTimeout(() => (this.wait = false), 3000);
    },
    saveExcel() {
      this.dialog = false;
      this.wait = true;
    },
    async getConsumptions() {
      const start = new Date(this.options.start_date).getTime();
      const end = new Date(this.options.end_date).getTime();
      const res = this.$communicator.then(
        this,
        await this.$communicator("get_consumptions", {
          arguments: [10, this.page],
          params: {
            startDate: start,
            endDate: end,
            fee_type: this.options.fee_type,
            filter: this.options.filter,
            amount_type: this.options.amount_type,
            service: this.options.service,
          },
        })
      );
      if (res && res.fees instanceof Array) {
        this.fees_total = Math.ceil(res.total / 10);
        for (const index in res.fees) {
          if (res.fees[index].type == "company_to_fees") {
            res.fees[index].for = res.fees[index].supplier_name;
          } else if (res.fees[index].type == "salary") {
            res.fees[index].for = res.fees[index].employee_name;
          } else {
            res.fees[index].for = res.fees[index].service_name;
          }
        }
        this.fees = res.fees;
      }
    },
  },
  mounted() {
    this.headers = [
      { text: this.$t("type"), value: "type", available: true },
      { text: this.$t("employee"), value: "by_name", available: true },
      { text: this.$t("to"), value: "for", available: true },
      { text: this.$t("store"), value: "service_name", available: true },
      { text: this.$t("comment"), value: "comment", available: true },
      { text: this.$t("date"), value: "date", width: 150, available: true },
      {
        text: this.$t("amount_type"),
        value: "amount_type",
        width: 120,
        available: true,
      },
      {
        text: this.$t("amount"),
        value: "currency_amount",
        align: "right",
        width: 100,
        available: true,
      },
    ];
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
    this.getConsumptions();
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>
